import React, { useEffect } from 'react';
import { Container, Row, Col, Card, Spinner } from 'react-bootstrap';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { verifyEmail } from '../../../redux/authSlice';
import { toast } from 'react-toastify';

const VerifyEmail = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, success, message, error } = useSelector((state) => state.auth);
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  useEffect(() => {
    if (token) {
      dispatch(verifyEmail(token))
        .unwrap()
        .then((res) => {
          toast.success(res.message);
          navigate("/");
        })
        .catch((err) => toast.error(err.message));
    } else {
      toast.error("Invalid or missing verification token.");
    }
  }, [token, dispatch]);

  return (
    <Container className=" justify-content-center align-items-center">
      <Row>
        <Col lg={6} className="offset-lg-3 mt-5">
          <Card>
            <Card.Body className="text-center">
              <h2>Email Verification</h2>
              {loading ? (
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Verifying...</span>
                </Spinner>
              ) : success ? (
                <p className="text-success">Your email has been successfully verified.</p>
              ) : error ? (
                <p className="text-danger">{error}</p>
              ) : null}
              {message && <p>{message}</p>}
              <Link to="/login" className='btn btn-primary'>Go to Login Page</Link>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default VerifyEmail;
